import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Box, styled } from '@mui/material';
var StyledPopupContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;

  var styles = _defineProperty({
    padding: theme.spacing(4),
    borderRadius: theme.typography.pxToRem(16)
  }, theme.breakpoints.down('tablet'), {
    padding: theme.spacing(3)
  });

  return styles;
});
export { StyledPopupContainer };